import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

// Helper to get default date range (last Sunday to next Saturday)
const getDefaultDateRange = () => {
  const lastSunday = moment().subtract(1, 'week').startOf('week');
  const nextSaturday = moment().add(1, 'week').endOf('week');
  return {
    startDate: lastSunday.format('YYYY-MM-DD'),
    endDate: nextSaturday.format('YYYY-MM-DD'),
    includeRecordsWithNullReleaseDate: false,
  };
};

const initialState = {
  selectedReleases: [],
  projectFilterMode: 'project',
  selectedJqlFilterId: null,
  filters: {},
  dateRange: getDefaultDateRange(),
  lastUpdated: null,
};

const releaseQADashboardSlice = createSlice({
  name: 'releaseQADashboard',
  initialState,
  reducers: {
    resetDashboard: () => ({
      ...initialState,
      dateRange: getDefaultDateRange(),
    }),
    setSelectedReleases: (state, action) => {
      state.selectedReleases = action.payload;
      state.lastUpdated = new Date().toISOString();
    },
    setProjectFilterMode: (state, action) => {
      state.projectFilterMode = action.payload;
    },
    setSelectedJqlFilterId: (state, action) => {
      state.selectedJqlFilterId = action.payload;
    },
    setFilter: (state, action) => {
      const { filterKey, value } = action.payload;
      state.filters[filterKey] = value;
      state.lastUpdated = new Date().toISOString();
    },
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
      state.lastUpdated = new Date().toISOString();
    },
    replaceFilters: (state, action) => {
      state.filters = action.payload ?? {};
      state.lastUpdated = new Date().toISOString();
    },
    clearAllFilters: (state) => {
      state.filters = {};
      state.lastUpdated = new Date().toISOString();
    },
    clearSelectedReleases: (state) => {
      state.selectedReleases = [];
      state.lastUpdated = null;
    },
    setDateRange: (state, action) => {
      state.dateRange = {
        ...state.dateRange,
        ...action.payload,
      };
      state.lastUpdated = new Date().toISOString();
    },
    setNullToggle: (state, action) => {
      state.dateRange.includeRecordsWithNullReleaseDate = action.payload;
      state.lastUpdated = new Date().toISOString();
    },
    resetFilters: (state) => {
      state.selectedReleases = [];
      state.filters = {};
      state.dateRange = getDefaultDateRange();
      state.lastUpdated = null;
    },
  },
});

export const {
  resetDashboard,
  setSelectedReleases,
  setProjectFilterMode,
  setSelectedJqlFilterId,
  setFilter,
  setFilters,
  replaceFilters,
  clearAllFilters,
  clearSelectedReleases,
  setDateRange,
  setNullToggle,
  resetFilters,
} = releaseQADashboardSlice.actions;

export default releaseQADashboardSlice.reducer;
